import React, {useContext} from 'react'
import {AppBar, Toolbar, IconButton, Button, InputBase} from '@material-ui/core'
import MovieFilterIcon from '@material-ui/icons/MovieFilter'
import OndemandVideoIcon from '@material-ui/icons/OndemandVideo'
import ThemeContext from '../theme-context'
import GuideSearchBar from './GuideSearchBar'

import {useSelector} from 'react-redux'

export default function Header(props) {
    const {theme, changeTheme} = useContext(ThemeContext);
    const media = useSelector(state => state.media);
    return (
        <>
            <AppBar position="static" color={theme}>
                <Toolbar variant="dense">
                    <h5>Fun Pokémon Guide</h5>
                </Toolbar>
            </AppBar>
            <br />
        </>
    )
}

